import * as h from "react";
import o from "react";
import { g as y, c as E } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { f as j } from "./formControlState-vgaj2ksH.mjs";
import { u as F } from "./useFormControl-C9UMlaFq.mjs";
import { m as g } from "./memoTheme-BzXKG_-k.mjs";
import { c as k } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as w } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import { s as b, u as I, c as Z } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { c as q } from "./tss-DN0acMKN.mjs";
import { f as z } from "./index-LyFokDcn.mjs";
import { I as f } from "./icon-v2-DGtVEk7e.mjs";
function $(e) {
  return y("MuiFormLabel", e);
}
const n = w("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), B = (e) => {
  const {
    classes: r,
    color: c,
    focused: a,
    disabled: d,
    error: l,
    filled: u,
    required: i
  } = e, p = {
    root: ["root", `color${q(c)}`, d && "disabled", l && "error", u && "filled", a && "focused", i && "required"],
    asterisk: ["asterisk", l && "error"]
  };
  return Z(p, $, r);
}, N = b("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, r) => ({
    ...r.root,
    ...e.color === "secondary" && r.colorSecondary,
    ...e.filled && r.filled
  })
})(g(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(k()).map(([r]) => ({
    props: {
      color: r
    },
    style: {
      [`&.${n.focused}`]: {
        color: (e.vars || e).palette[r].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${n.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${n.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), S = b("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, r) => r.asterisk
})(g(({
  theme: e
}) => ({
  [`&.${n.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), r3 = /* @__PURE__ */ h.forwardRef(function(r, c) {
  const a = I({
    props: r,
    name: "MuiFormLabel"
  }), {
    children: d,
    className: l,
    color: u,
    component: i = "label",
    disabled: p,
    error: H,
    filled: O,
    focused: U,
    required: G,
    ...R
  } = a, M = F(), s = j({
    props: a,
    muiFormControl: M,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), m = {
    ...a,
    color: s.color || "primary",
    component: i,
    disabled: s.disabled,
    error: s.error,
    filled: s.filled,
    focused: s.focused,
    required: s.required
  }, C = B(m);
  return /* @__PURE__ */ t.jsxs(N, {
    as: i,
    ownerState: m,
    className: E(C.root, l),
    ref: c,
    ...R,
    children: [d, s.required && /* @__PURE__ */ t.jsxs(S, {
      ownerState: m,
      "aria-hidden": !0,
      className: C.asterisk,
      children: [" ", "*"]
    })]
  });
}), x = (e) => o.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 13 13", width: "13", height: "13" }, e),
  o.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    o.createElement(
      "g",
      { fillRule: "nonzero" },
      o.createElement("path", { d: "M293.5,6 C289.910375,6 287,8.910375 287,12.5 C287,16.09125 289.910375,19 293.5,19 C297.089625,19 300,16.09125 300,12.5 C300,8.910375 297.089625,6 293.5,6 Z M292.958333,9.25 C292.958333,8.951 293.201,8.70833333 293.5,8.70833333 C293.799,8.70833333 294.041667,8.95045833 294.041667,9.25 L294.041667,13.0416667 C294.041667,13.3406667 293.799,13.5833333 293.5,13.5833333 L293.499458,13.5833333 C293.200458,13.5833333 292.957792,13.3412083 292.957792,13.0416667 L292.957792,9.25 L292.958333,9.25 Z M293.5,16.2916667 C293.0515,16.2916667 292.6875,15.9276667 292.6875,15.4791667 C292.6875,15.0306667 293.0515,14.6666667 293.5,14.6666667 C293.9485,14.6666667 294.3125,15.0306667 294.3125,15.4791667 C294.3125,15.9276667 293.9485,16.2916667 293.5,16.2916667 Z", transform: "translate(-287 -6)" })
    )
  )
);
x.displayName = "CircleExclamation13x13";
const L = (e) => o.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 13 13", width: "13", height: "13" }, e),
  o.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    o.createElement(
      "g",
      { fillRule: "nonzero" },
      o.createElement("path", { d: "M316.5,3 C312.910375,3 310,5.90875 310,9.5 C310,13.089625 312.910375,16 316.5,16 C320.089625,16 323,13.089625 323,9.5 C323,5.90875 320.089625,3 316.5,3 Z M317.041667,12.75 C317.041667,13.049 316.799,13.2916667 316.5,13.2916667 C316.201,13.2916667 315.958333,13.049 315.958333,12.75 L315.958333,8.95833333 C315.958333,8.65933333 316.201,8.41666667 316.5,8.41666667 C316.799,8.41666667 317.041667,8.65933333 317.041667,8.95833333 L317.041667,12.75 Z M316.5,7.33333333 C316.0515,7.33333333 315.6875,6.96933333 315.6875,6.52083333 C315.6875,6.07233333 316.0515,5.70833333 316.5,5.70833333 C316.9485,5.70833333 317.3125,6.07233333 317.3125,6.52083333 C317.3125,6.96933333 316.9485,7.33333333 316.5,7.33333333 Z", transform: "translate(-310 -3)" })
    )
  )
);
L.displayName = "InfoCircle13x13";
const v = (e) => o.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 13 11", width: "13", height: "11" }, e),
  o.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    o.createElement(
      "g",
      { fillRule: "nonzero" },
      o.createElement("path", { d: "M872.735655,8832.24994 L868.221306,8824.92627 C867.460248,8823.69124 865.539456,8823.69124 864.778397,8824.92627 L860.264049,8832.24994 C859.508949,8833.47547 860.463387,8835 861.985503,8835 L871.0142,8835 C872.536859,8835 873.491296,8833.47547 872.735655,8832.24994 Z M865.958173,8826.99982 C865.958173,8826.72381 866.200845,8826.49981 866.499852,8826.49981 C866.798858,8826.49981 867.04153,8826.72331 867.04153,8826.99982 L867.04153,8830.4999 C867.04153,8830.7759 866.798858,8830.99991 866.499852,8830.99991 L866.49931,8830.99991 C866.200304,8830.99991 865.957632,8830.7764 865.957632,8830.4999 L865.957632,8826.99982 L865.958173,8826.99982 Z M866.5,8833.49997 C866.086,8833.49997 865.75,8833.16396 865.75,8832.74995 C865.75,8832.33594 866.086,8831.99993 866.5,8831.99993 C866.914,8831.99993 867.25,8832.33594 867.25,8832.74995 C867.25,8833.16396 866.914,8833.49997 866.5,8833.49997 Z", transform: "translate(-860 -8824)" })
    )
  )
);
v.displayName = "TriangleExclamation13x11";
const _ = () => z.ifFeature(
  "encore",
  {
    error: /* @__PURE__ */ t.jsx(f, { color: "error-medium", name: "circle-exclamation-solid", size: 16 }),
    info: /* @__PURE__ */ t.jsx(f, { color: "info-medium", name: "circle-info-solid", size: 16 }),
    warning: /* @__PURE__ */ t.jsx(f, { color: "warning-medium", name: "triangle-exclamation-solid", size: 16 })
  },
  {
    info: /* @__PURE__ */ t.jsx(L, {}),
    error: /* @__PURE__ */ t.jsx(x, {}),
    warning: /* @__PURE__ */ t.jsx(v, {})
  }
), o3 = (e) => e ? _()[e] : null;
export {
  r3 as F,
  n as f,
  o3 as u
};
//# sourceMappingURL=use-input-icon-Dk75O5Ch.mjs.map
